export default __webpack_public_path__ + "img/pin_icons/up_down_w.svg";